import { GET_USERS_LIST } from '../actions/types';
import isEmpty from '../validation/is-empty';

const initialState = {
  list: []
}

export default function(state = initialState, action ) {
    switch(action.type) {
        case GET_USERS_LIST:
            // console.log(action.type);
            // console.log(action.payload);
            return {
                ...state,
                list: action.payload
            }
        default:
            return state;
    }
}
